// Small reusable phone-action component — renders Call + WhatsApp (+ optional SMS)
// buttons for any phone number, so users don't rely on device long-press behaviour.
import { Phone, WhatsappLogo, ChatCenteredText } from "@phosphor-icons/react";
import { toWhatsAppNumber } from "@/lib/contact";

export default function PhoneActions({ phone, size = "sm", withSms = false, className = "" }) {
  if (!phone) return null;
  const cleaned = String(phone).replace(/[^\d+]/g, "");
  const wa = toWhatsAppNumber(phone);
  const h = size === "xs" ? "h-7 px-2 text-[11px]" : size === "lg" ? "h-10 px-3 text-sm" : "h-8 px-2.5 text-xs";
  const icon = size === "xs" ? 12 : size === "lg" ? 16 : 14;
  const base = "inline-flex items-center gap-1 rounded-md border font-medium transition-colors";

  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`}>
      <a
        data-testid={`phone-action-call-${cleaned}`}
        href={`tel:${cleaned}`}
        className={`${base} ${h} bg-emerald-500/10 text-emerald-400 border-emerald-500/30 hover:bg-emerald-500/20`}
      >
        <Phone size={icon} weight="fill" /> Call
      </a>
      <a
        data-testid={`phone-action-wa-${cleaned}`}
        href={`https://wa.me/${wa}`}
        target="_blank"
        rel="noopener noreferrer"
        className={`${base} ${h} bg-[#25D366]/10 text-[#25D366] border-[#25D366]/30 hover:bg-[#25D366]/20`}
      >
        <WhatsappLogo size={icon} weight="fill" /> WhatsApp
      </a>
      {withSms && (
        <a
          data-testid={`phone-action-sms-${cleaned}`}
          href={`sms:${cleaned}`}
          className={`${base} ${h} bg-sky-500/10 text-sky-400 border-sky-500/30 hover:bg-sky-500/20`}
        >
          <ChatCenteredText size={icon} weight="fill" /> SMS
        </a>
      )}
    </div>
  );
}
